






























































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import * as Reveal from '@/assets/scripts/RevealOnScrollModule'
import * as Smooth from '@/assets/scripts/SmoothScrollModule'


@Component
export default class SmoothScroll extends Vue {
	data() {
		return {
			PageTitle: "SmoothScroll with reaveal"
		}
	}
	mounted(): void {
			new Smooth.SmoothScrollModule();
		new Reveal.revealOnScrollModule();

	}
}
